import type * as QueryRepository from "@/components/features/dialog/re-onboarding-request/repository/query";

export const serverModelToInputModelConverter = (serverModel: QueryRepository.ServerModel) => {
	const { hotel } = serverModel;
	return {
		hotelID: hotel.hotelID,
		updatedEmail: hotel.email || "",
		message: "",
	};
};
